export * from './wk-decorators.component';
